/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Windows_ArchInputs */

const en_gc_resources_download_windows_arch = /** @type {(inputs: Gc_Resources_Download_Windows_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`64-bit Windows · x64 installer`)
};

const zh_gc_resources_download_windows_arch = /** @type {(inputs: Gc_Resources_Download_Windows_ArchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`64 位 Windows · x64 安装包`)
};

/**
* | output |
* | --- |
* | "64-bit Windows · x64 installer" |
*
* @param {Gc_Resources_Download_Windows_ArchInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_windows_arch = /** @type {((inputs?: Gc_Resources_Download_Windows_ArchInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Windows_ArchInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_windows_arch(inputs)
	return zh_gc_resources_download_windows_arch(inputs)
});
export { gc_resources_download_windows_arch as "gc.resources.download.windows.arch" }